"use client";

import type { ReactNode } from "react";
import { useInjectStyles } from "../utils/useInjectStyles";

export interface PageHeaderProps {
  /** 頁面標題（20px/700）。詞條沿用選單原文，一字不改。 */
  title: ReactNode;
  /** 麵包屑（通常是所屬群組名，如「➊ 網站管理」）。 */
  breadcrumb?: ReactNode;
  /** 標題右側的通道徽章等標記。 */
  badge?: ReactNode;
  /** 右側動作區（「＋新增」、「顯示被刪除」核取方塊等）。 */
  actions?: ReactNode;
  /**
   * 標題下方的一行說明（13px/muted）。
   *
   * 為什麼要進共用元件：副標題在視覺上屬於標題區，但 PageHeader 沒有這個 slot 時，
   * 呼叫端只能把 <p> 放在 PageHeader 外面，再用負 margin 把它拉回標題底下——
   * 那個負值必須跟 PageHeader 內部的 margin-bottom 保持同步，元件一改間距就會裂開。
   */
  subtitle?: ReactNode;
  /** 隱藏標題下方的分隔線。 */
  hideDivider?: boolean;
}

/**
 * 頁面標頭（2026-09-02 視覺翻新新增）。
 *
 * 改版前每頁自行用 14px/600 的文字當標題，與內文層級幾乎沒有差別，而且沒有
 * 統一的動作區位置。抽成共用元件後，75 個清單頁的標題、麵包屑、主 CTA 位置一致。
 */
export function PageHeader({ title, breadcrumb, badge, actions, subtitle, hideDivider }: PageHeaderProps) {
  useInjectStyles();
  return (
    <div className="cui-reset cui-page-header">
      {breadcrumb !== undefined && <div className="cui-page-breadcrumb">{breadcrumb}</div>}
      <div className="cui-page-header-row">
        <h1 className="cui-page-title">{title}</h1>
        {badge}
        {actions !== undefined && <div className="cui-page-actions">{actions}</div>}
      </div>
      {subtitle !== undefined && <p className="cui-page-subtitle">{subtitle}</p>}
      {!hideDivider && <div className="cui-page-header-line" />}
    </div>
  );
}
